// An empty REACT_APP_API_BASE_URL means "call the API on this same origin".
// Netlify then proxies /api/* through to the backend, which keeps the session
// cookie first-party. That matters: when the browser talks straight to
// starsema-backend.onrender.com the cookie is third-party, and Safari, Firefox,
// Brave and Chrome incognito block those by default, so login appears to
// succeed and every following request comes back 401.
//
// Unset (local development) still falls back to the local backend.
const configured = process.env.REACT_APP_API_BASE_URL;
const configuredBaseUrl =
  configured === undefined || configured === null
    ? "http://localhost:4242"
    : String(configured);

export const API_BASE_URL = configuredBaseUrl.trim().replace(/\/+$/, "");
